












import Vue from 'vue'
export default Vue.extend({
  name: 'HeavyTicketsHeader',
  props: {
    grouped: {
      type: Boolean,
      required: false,
      default: false
    },
    modoAlleamento: {
      type: String,
      required: true
    }
  },
  computed: {
    specieHeaderContent (): string {
      return this.grouped === false
        ? this.$t('expediente.execucionTab.especieFormaHeader').toString()
        : this.$t('expediente.execucionTab.especieHeader').toString()
    }
  }
})
